import "promise-polyfill/src/polyfill";

const loadPreview = (scriptSource, callback) => {
  const scriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    document.body.appendChild(script);
    script.onload = resolve;
    script.onerror = reject;
    script.async = true;
    script.src = scriptSource;
  });

  scriptPromise.then(() => {
    callback();
  });
};

export default loadPreview;
